import { getRequest, postRequest } from '@/api/request';

export const fetchApprovalTemplates = () => getRequest({
  url: '/jobprofile/approval-templates/list-templates',
});

export const fetchApprovalFlowsByDraft = ({ draftUlid }) => getRequest({
  url: `/jobprofile/approval-flow/by-draft?ulid=${encodeURIComponent(draftUlid)}`,
});

export const fetchMyPendingApprovals = () => getRequest({
  url: '/jobprofile/approval-flow/my-pending',
});

export const fetchApprovalFlow = ({ flowUlid }) => getRequest({
  url: `/jobprofile/approval-flow/view?ulid=${encodeURIComponent(flowUlid)}`,
});

export const fetchApprovalFlowRevision = ({ revisionUlid }) => getRequest({
  url: `/jobprofile/approval-flow/revision?ulid=${encodeURIComponent(revisionUlid)}`,
});

export const approveApprovalSlot = ({ approvalFlowSlotUlid }) => postRequest({
  url: '/jobprofile/approval-flow/approve',
  body: { approvalFlowSlotUlid },
});

export const rejectApprovalSlot = ({ approvalFlowSlotUlid }) => postRequest({
  url: '/jobprofile/approval-flow/reject',
  body: { approvalFlowSlotUlid },
});

export const createApprovalFlow = ({
  templateUlid,
  draftJobProfileUlid,
  slots,
}) => postRequest({
  url: '/jobprofile/approval-flow/create',
  body: {
    templateUlid,
    draftJobProfileUlid,
    slots,
  },
});

export const cancelApprovalFlow = ({ flowUlid }) => postRequest({
  url: '/jobprofile/approval-flow/cancel',
  body: { flowUlid },
});

export const addApprovalFlowApprovers = ({ approvalFlowSlotUlid, userUlids, approvalFlowUlid }) => postRequest({
  url: '/jobprofile/approval-flow/add-approvers',
  body: { approvalFlowSlotUlid, userUlids, approvalFlowUlid },
});

export const remindApprovalFlowApprover = ({ approvalFlowSlotUlid, userUlid }) => postRequest({
  url: '/jobprofile/approval-flow/reminder',
  body: { approvalFlowSlotUlid, userUlid },
});
